import { render, staticRenderFns } from "./InactiveUserPopover.vue?vue&type=template&id=487c6354&scoped=true"
import script from "./InactiveUserPopover.vue?vue&type=script&lang=ts"
export * from "./InactiveUserPopover.vue?vue&type=script&lang=ts"
import style0 from "./InactiveUserPopover.vue?vue&type=style&index=0&id=487c6354&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487c6354",
  null
  
)

export default component.exports